import { action } from '@ember/object';
import Component from '@glimmer/component';
import type { Neighborhood, Floor } from 'garaje/types/maps/live-map/LiveMapServiceV2';
import type { Maybe } from 'graphql/jsutils/Maybe';
import type { Map } from 'leaflet';

import type { ResourceIconConfig, ResourceMapPoint } from '../resource-map/base-map/component';
interface MapExternalHeaderArgs {
  leafletMap: Maybe<Map>;
  floors: Floor[];
  neighborhoods: Neighborhood[];
  selectedNeighborhoods: Neighborhood[];
  setSelectedNeighborhoods: (neighborhoods: Neighborhood[]) => void;
  resourceConfig: ResourceIconConfig;
  resourceMapPoints: ResourceMapPoint[];
  shareMapDimensions: (dimensions: [number, number]) => void;
  pageTitle: string;
}

export default class MapExternalHeader extends Component<MapExternalHeaderArgs> {
  get sortedMapFloors(): Floor[] {
    if (!this.args.floors || this.args.floors.length === 0) {
      return [];
    }
    const mapFloors = [...this.args.floors];
    return mapFloors.sort((a, b) => (a.ordinality || 0) - (b.ordinality || 0)).filter((floor) => floor.image);
  }

  @action
  searchNeighborhood(searchTerm: string): Neighborhood[] {
    return this.args.neighborhoods?.filter((neighborhood) =>
      neighborhood.name.toLowerCase().includes(searchTerm.toLowerCase()),
    );
  }
}
